var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "legend-container row" },
    [
      _c("div", { staticClass: "col-12 title" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._l(_vm.legendData, function(legend) {
        return _c("div", { key: legend.id, staticClass: "col px-0" }, [
          _c("div", {
            staticClass: "color",
            style: { "background-color": legend.color }
          }),
          _c("div", { staticClass: "legend-info" }, [
            _c("span", { staticClass: "legend-name" }, [
              _vm._v(" " + _vm._s(legend.name) + " ")
            ]),
            _c("span", { staticClass: "legend-description" }, [
              _vm._v(" " + _vm._s(legend.description) + " ")
            ])
          ])
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }